<div class="referral-details-container">
  <div class="referral-details-wrapper">

    <div class="referral-details-header">
      <h3>Рефералы</h3>
      <mat-icon class="close" (click)="close()">close</mat-icon>
    </div>

    <mat-divider></mat-divider>

    <div>
      <mat-table [dataSource]="referralsDetails" class="referral-details-table" matSort>

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
        </ng-container>


        <!-- user Column -->
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef>Пользователь</mat-header-cell>
          <mat-cell *matCellDef="let element"><a
            [routerLink]="['/user/', element.user.id]">{{element.user.name}}</a></mat-cell>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.status}}</mat-cell>
        </ng-container>

        <!-- activated Column -->
        <ng-container matColumnDef="activated">
          <mat-header-cell *matHeaderCellDef>Активирован</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.activated ? 'Да' : 'Нет'}}</mat-cell>
        </ng-container>

        <!-- createdAt Column -->
        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef>Создан</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.createdAt | date: 'dd.MM.yy HH:mm'}} </mat-cell>
        </ng-container>

        <!-- rewardCoins Column -->
        <ng-container matColumnDef="rewardCoins">
          <mat-header-cell *matHeaderCellDef
                           matTooltip="Накопленный денормализованный результат уже перенесённых циклов этого реферала. Состояние модерации и вывода ведётся на уровне кампании."
                           matTooltipPosition="above">Начислено по рефералу</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.rewardCoins / 100 | currency : 'USD'}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="referralsColumn; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: referralsColumn;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
    </div>
  </div>
</div>
